import React from 'react';

// Shared search input (icon + text field + submit button) used across the warehouses list pages.
export default function TableSearchBar({ value, onChange, onSubmit, placeholder, submitLabel = 'Hledat', className = '' }) {
  return (
    <form onSubmit={onSubmit} className={`d-flex gap-2 flex-grow-1 ${className}`}>
      <div className="input-icon flex-grow-1">
        <input
          type="text"
          value={value}
          onChange={onChange}
          className="form-control"
          placeholder={placeholder}
        />
        <span className="input-icon-addon">
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
            <path d="M21 21l-6 -6"></path>
          </svg>
        </span>
      </div>
      <button type="submit" className="btn btn-primary">{submitLabel}</button>
    </form>
  );
}
